export const FETCH_FIRMS_LIST_REQUEST = "FETCH_FIRMS_LIST_REQUEST";
export const FETCH_FIRMS_LIST_SUCCESS = "FETCH_FIRMS_LIST_SUCCESS";
export const FETCH_FIRMS_LIST_FAILURE = "FETCH_FIRMS_LIST_FAILURE";

export const RESET_FIRMS_LIST_DATA = "RESET_FIRMS_LIST_DATA";

export const SELECTED_FIRM = "SELECTED_FIRM";
